let faqList = [
    {
        q: 'インターネットが繋がっていれば、どこでも視聴可能ですか？',
        a: 'ネット速度が十分であれば、基本的に世界中どこでも視聴は可能です。ただ、ホテル等の共同回線などの場合は視聴するにあたり設定が必要になる場合もございます。 ※ご契約前に視聴テストをしてからお申込みすることをお勧めいたします。',
        isShow: false
    },
    {
        q: '視聴できない国、地域はありますか？',
        a: 'インターネット環境があれば、基本的には世界中どこの国・地域でも視聴可能です。<br/>※ご契約前に視聴テストをしてからお申込みすることをお勧めいたします。',
        isShow: false
    },
    {
        q: '視聴に必要なインターネット速度はどれくらいですか？',
        a: '実測値で4Mbps以上あれば視聴が可能です。',
        isShow: false
    },
    {
        q: '契約完了後、どれぐらいで視聴可能になりますか？',
        a: 'スマホやタブレットでの1週間無料体験は、申し込み後即時に視聴が可能です。ただ、FireTV Stick、Googleplay対応の端末等は、ID及びパスワード発行後に視聴可能となりますため、即時発行を目指しておりますが、業務時間外やメンテナンス中などで24時間ほどかかる場合もございます。予めご了承ください。',
        isShow: false
    },
    {
        q: '契約キャンセルは可能ですか？',
        a: 'ご支払後のキャンセルは、商品の性質上お受けいたしかねます｡　予めご了承ください。',
        isShow: false
    },
    {
        q: '英語での契約に不安がありますが、日本語でのサポートはありますか？',
        a: 'お問い合わせからご契約、その後のトラブル対応など、全て日本語での対応となります。ご安心ください。',
        isShow: false
    },
    {
        q: '初期費用は必要ですか？',
        a: '入会金等は一切かかりません。ご希望プランに応じた月額利用料のみとなります。',
        isShow: false
    },
    {
        q: 'お支払方法はどうなりますか？',
        a: 'お支払方法は基本的にはカード決済となります。VISA、Masterがご利用いただけます。海外決済のお申し込みがされていないカード等一部決済できない場合もございますので、その際はご相談ください。',
        isShow: false
    },
    {
        q: '録画予約操作は難しいですか？',
        a: '個々に録画予約していただく必要はございません。直近4週間分の全番組を自動的に録画保存しており、好きなタイミングで視聴することが可能です。',
        isShow: false
    },
    {
        q: '1つのアカウントで何台まで視聴可能ですか？',
        a: 'iPhone,iPad,Android Phone,Google Play 対応タブレット、Smart TV/Smart TV BOX、FireTV Stick等、同じIDを様々なデバイスでご利用いただくことが可能です。<br/>ただし、同時ログインや同時視聴は出来ません。予めご了承ください。',
        isShow: false
    },
    {
        q: '事前に用意しておく必要があるものはありますか？',
        a: '既にお持ちのスマホやタブレット等で視聴が可能ですので、それ以外に何かを追加でご用意していただく必要はございません。',
        isShow: false
    },
    {
        q: '突然、TV視聴が出来なくなりました。どうしたらいいですか？',
        a: 'まず、インターネットに接続されているかご確認ください。同時に視聴可能なネット速度が出ているか確認ください。www.speedtest.netにアクセスいただくか、スマホのアプリ等でネット速度を確認が可能です。インターネット接続に問題がなく、視聴不具合が解消されない場合は直接弊社までお問い合わせください。',
        isShow: false
    }
]
export default faqList